import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import ChatData from "./ChatData";

const Chat = ({  }) => {
  return (
    <React.Fragment>
        <ChatData /> 
    </React.Fragment>
  );
};


export default connect()(Chat);
